import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import LoadingOverlay from "../components/features/loading-overlay";

import { scrollTop } from "../utils";
import WhatsAppPopup from "../components/features/whatsapp-popup/index.js";

const OtherPages = React.lazy(() => import("./others-route.js"));
const HomePage = React.lazy(() => import("./home-route.js"));

export default function AppRoot() {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <>
      {/* <WhatsAppPopup /> */}
      <React.Suspense fallback={<LoadingOverlay />}>
        <Switch>
          <Route path={`${process.env.PUBLIC_URL}/pages`} component={OtherPages} />
          <Route path={`${process.env.PUBLIC_URL}/`} component={HomePage} />
        </Switch>
      </React.Suspense>
    </>
  );
}

